import { getAnalytics, isSupported, logEvent, setUserId } from "@firebase/analytics";
const getAnalyticsIfSupported = async () => {
    try {
        if (!(await isSupported())) {
            return null;
        }
        return getAnalytics();
    }
    catch (error) {
        console.log("Firebase Analytics unavailable", error);
        return null;
    }
};
export const safeSetAnalyticsUserId = async (userId) => {
    if (!userId) {
        return;
    }
    try {
        const analytics = await getAnalyticsIfSupported();
        if (!analytics) {
            return;
        }
        setUserId(analytics, userId);
    }
    catch (error) {
        console.log("Firebase Analytics setUserId failed", error);
    }
};
export const safeLogAnalyticsEvent = async (eventName, eventParams) => {
    try {
        const analytics = await getAnalyticsIfSupported();
        if (!analytics) {
            return;
        }
        logEvent(analytics, eventName, eventParams);
    }
    catch (error) {
        console.log("Firebase Analytics logEvent failed", error);
    }
};
